import type { Program, SuggestedProgram, WbProgram } from '@/types'

/**
 * A program name as the quick adds compare it (PC-31): lowercased, without
 * punctuation or whitespace, so "Pre-Med", "Pre Med" and "premed" are one name.
 */
export const matchKey = (name: string) => name.toLowerCase().replace(/[\p{P}\p{S}\s]/gu, '')

/**
 * The suggestions the client does not have yet, in the list's order. A
 * suggestion is taken when a WB program's name, or any crawled program's name
 * (merged or rejected ones included), matches its name or a variation: a
 * program the crawl already found holds the name, though it may sit unassigned.
 */
export function unusedSuggestions(
  suggestions: SuggestedProgram[],
  wbPrograms: Pick<WbProgram, 'name'>[],
  programs: Pick<Program, 'name'>[],
): SuggestedProgram[] {
  const taken = new Set([...wbPrograms, ...programs].map((p) => matchKey(p.name)))
  return suggestions.filter((s) => ![s.name, ...s.variations].some((n) => taken.has(matchKey(n))))
}
